import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { TaskApprovementStatusEnum } from '@zaoblako/shared/modules/task/enum/task.approvement.status.enum';

import * as yup from 'yup';

export interface TaskApproverFindInterface {
  /** Approval statues */
  status: TaskApprovementStatusEnum;
  /** Approver user */
  user: UserFindInterface;
  /** Can current user approve */
  canApprove: boolean;
  /** Approver last update date */
  updated: Date;
}

export const TaskApproverFindDto = SerdeDtoClass.create<TaskApproverFindInterface>(TaskDtoKeysEnum.TASKS_APPROVER_FIND_DTO, {
  status: {
    label: 'Статус',
    serializer: yup
      .string()
      .oneOf(Object.values(TaskApprovementStatusEnum)),
  },
  user: {
    label: 'Пользователь',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  canApprove: {
    label: 'Утверждено',
    serializer: yup.boolean(),
  },
  updated: {
    label: 'Обновлено',
    serializer: yup.date(),
  },
});
